import { Pipe, PipeTransform, Signal } from '@angular/core';
import { ApiSignal, WritableApiSignal, apiErrorSymbol } from '../util/api-signal';

@Pipe({
  name: 'apiError',
  standalone: true,
  pure: false,
})
export class ApiErrorPipe implements PipeTransform {
  public transform<T>(value: WritableApiSignal<T> | ApiSignal<T>): Signal<Error> | undefined {
    return value[apiErrorSymbol] as Signal<Error>;
  }
}
